// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General App Container */
.app-container {
  display: flex;
  height: 100vh;
  overflow: hidden;
  flex-direction: column;
}

/* Two-Pane Layout for Other Pages */
.form-container {
  width: 65vw;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 20px;
  box-sizing: border-box;
}

.json-output {
  width: 35vw;
  display: flex;
  flex-direction: column;
  background-color: #121212;
  color: #FFD700;
  padding: 20px;
  overflow-y: auto;
  height: 100%;
  box-sizing: border-box;
  position: absolute;
  right: 0;
  -webkit-user-select: none;
          user-select: none;
}

/* General Form Group Styling */
.form-group {
  margin-bottom: 10px;
}

.form-group label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
}

.form-group input, textarea {
  width: 100%;
  padding: 8px;
  font-size: 16px;
  font-family: 'Arial', sans-serif;
  color: #000000;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  margin-bottom: 10px;
}

/* General Button Styles */
/* button {
  display: inline-block;
  padding: 10px 15px;
  font-size: 16px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  background-color: #007bff;
  color: white;
  transition: background-color 0.3s ease;
}

button:active {
  background-color: #0056b3;
}

button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
} */

/* Specific Button Styles */
.remove-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: red;
}

.remove-button:hover {
  background-color: darkred;
}

.save-button {
  background-color: #28a745;
  padding: 10px;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.edit-button {
  background-color: rgb(45, 45, 201);
  padding: 10px;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.edit-button:hover {
  background-color: Blue;
}

.cancel-button {
  padding: 10px;
  background-color: #ccc;
  color: black;
  border: none;
  border-radius: 4px;
  cursor: pointer;


}

.save-button:hover {
  background-color: #218838;
}

p {
  color: black;
}

.add-security-button,
.add-tag-button {
  width: 100%;
  margin-top: 15px;
}

/* Navigation Buttons */
.navigation-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.navigation-buttons button {
  background-color: #333;
  /* Dark background for contrast */
}

.navigation-buttons button:hover {
  background-color: #555;
  /* Lighter color on hover */
}

/* Containers */
.security-scheme,
.form-container>.form-group {
  border: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  position: relative;
}

/* Fixed Top Navigation Bar */
.navbar {
  width: 100%;
  height: 50px;
  /* Fixed height */
  background-color: #ffffff;
  color: #f2f5f500;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 20px;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  /* Ensures it stays on top */
  border-bottom: 2px solid #ccc;
  /* Separation line */
}

/* Navbar Links */
.navbar a {
  color: #1e1e1e;
  text-decoration: none;
  padding: 10px 15px;
  margin-left: 15px;
  font-weight: bold;
  border-radius: 4px;
}

.navbar a:hover {
  text-decoration: underline;
  background-color: transparent;
}

/* Main Content Area (Adjusted to not overlap Navbar) */
.main-content {
  display: flex;
  flex: 1 1;
  padding-top: 50px;
  overflow: hidden;
}

.profile-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: rgb(12,12,12);
}

.profile-card {
  width: 400px;
  padding: 20px;
  border-radius: 10px;
  background: rgb(12,12,12);
  text-align: center;
}

.profile-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  color: white;
}

.avatar {
  width: 80px;
  height: 80px;
  background: #007bff;
  color: white;
  font-size: 40px;
  font-weight: bold;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.profile-body {
  text-align: left;
}

.profile-field {
  margin-bottom: 15px;
}

.profile-field label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
  color: #fff;
}

.profile-field input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  background-color: #f9f9f9;
  box-sizing: border-box;
}

.profile-field input:read-only {
  background-color: #e9ecef;
  cursor: not-allowed;
}

.button-container {
  margin-top: 20px;
  display: flex;
  gap: 10px;
  justify-content: center;
}

.save-button {
  padding: 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.save-button:hover {
  background-color: #0056b3;
}

.cancel-button {
  padding: 10px;
  background-color: #ccc;
  color: black;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.cancel-button:hover {
  background-color: #b3b3b3;
}

/* Account container (wraps My Account and dropdown links) */
.account-container {
  position: relative;
  display: inline-block;
  font-weight: bold;
  cursor: pointer;
  padding: 10px 15px;
}

/* My Account link */
.account-links {
  display: none; /* Hidden by default */
  transition: opacity 0.3s ease-in-out;
  margin-left: 10px; /* Space from My Account */
}

/* Dropdown container (hidden by default) */
.account-dropdown {
  display: none;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%); /* Centers it under My Account */
  background: white;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  padding: 10px;
  min-width: 120px;
  text-align: center;
}

.account-link:hover {
  color: #007bff;
}

/* Dropdown links */
.account-links a {
  color: #333;
  text-decoration: none;
  padding: 10px;
  font-size: 14px;
  transition: color 0.3s ease-in-out;
}

/* Show dropdown when hovering over My Account */
.account-container:hover .account-dropdown {
  display: block;
}

/* Style on hover */
.account-links a:hover {
  color: #007bff;
  text-decoration: underline;
}

.account-container:hover .account-links {
  display: inline-block;
  opacity: 1;
}

/* Ensure content starts below the navbar */
.session-container {
  width: 90%;
  margin: 80px auto 30px;
  /* 80px margin from top to prevent navbar overlap */
  text-align: center;
}

/* Sessions Table */
.session-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.session-table th,
.session-table td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: center;
}

.session-table th {
  background-color: #2b6cb0;
  color: white;
  font-weight: bold;
}

.session-table tr {
  background-color: #f9f9f9;
}

.session-table tr:hover {
  background-color: #f1f1f1;
}

/* Revoke Button */
.revoke-button {
  background-color: #ff4d4d;
  color: white;
  border: none;
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 4px;
}

.revoke-button:hover {
  background-color: #cc0000;
}

/* No Sessions Found */
.no-sessions {
  text-align: center;
  font-style: italic;
  color: #888;
}

/* Delete Account Button */
.delete-account-button {
  background-color: red;
  color: white;
  border: none;
  padding: 12px 16px;
  margin-top: 20px;
  cursor: pointer;
  border-radius: 4px;
}

.delete-account-button:hover {
  background-color: darkred;
}

.delete-account-cancel-button {
  background-color: #ccc;
  color: black;
  border: none;
  padding: 12px 16px;
  margin-top: 20px;
  cursor: pointer;
  border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;;;;;;;;;;;;;;;;;;;GAmBG;;AAEH,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;;;AAGjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA,eAAe;AACf;;EAEE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,SAAO;EACP,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,aAAa,EAAE,sBAAsB;EACrC,oCAAoC;EACpC,iBAAiB,EAAE,0BAA0B;AAC/C;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B,EAAE,gCAAgC;EAC7D,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,kCAAkC;AACpC;;AAEA,gDAAgD;AAChD;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA,2CAA2C;AAC3C;EACE,UAAU;EACV,sBAAsB;EACtB,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB","sourcesContent":["/* General App Container */\n.app-container {\n  display: flex;\n  height: 100vh;\n  overflow: hidden;\n  flex-direction: column;\n}\n\n/* Two-Pane Layout for Other Pages */\n.form-container {\n  width: 65vw;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.json-output {\n  width: 35vw;\n  display: flex;\n  flex-direction: column;\n  background-color: #121212;\n  color: #FFD700;\n  padding: 20px;\n  overflow-y: auto;\n  height: 100%;\n  box-sizing: border-box;\n  position: absolute;\n  right: 0;\n  user-select: none;\n}\n\n/* General Form Group Styling */\n.form-group {\n  margin-bottom: 10px;\n}\n\n.form-group label {\n  display: block;\n  font-weight: bold;\n  margin-bottom: 5px;\n}\n\n.form-group input, textarea {\n  width: 100%;\n  padding: 8px;\n  font-size: 16px;\n  font-family: 'Arial', sans-serif;\n  color: #000000;\n  background: #fff;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-sizing: border-box;\n  margin-bottom: 10px;\n}\n\n/* General Button Styles */\n/* button {\n  display: inline-block;\n  padding: 10px 15px;\n  font-size: 16px;\n  border-radius: 4px;\n  border: none;\n  cursor: pointer;\n  background-color: #007bff;\n  color: white;\n  transition: background-color 0.3s ease;\n}\n\nbutton:active {\n  background-color: #0056b3;\n}\n\nbutton:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n} */\n\n/* Specific Button Styles */\n.remove-button {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background-color: red;\n}\n\n.remove-button:hover {\n  background-color: darkred;\n}\n\n.save-button {\n  background-color: #28a745;\n  padding: 10px;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.edit-button {\n  background-color: rgb(45, 45, 201);\n  padding: 10px;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.edit-button:hover {\n  background-color: Blue;\n}\n\n.cancel-button {\n  padding: 10px;\n  background-color: #ccc;\n  color: black;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n\n\n}\n\n.save-button:hover {\n  background-color: #218838;\n}\n\np {\n  color: black;\n}\n\n.add-security-button,\n.add-tag-button {\n  width: 100%;\n  margin-top: 15px;\n}\n\n/* Navigation Buttons */\n.navigation-buttons {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 20px;\n}\n\n.navigation-buttons button {\n  background-color: #333;\n  /* Dark background for contrast */\n}\n\n.navigation-buttons button:hover {\n  background-color: #555;\n  /* Lighter color on hover */\n}\n\n/* Containers */\n.security-scheme,\n.form-container>.form-group {\n  border: 1px solid #ccc;\n  padding: 10px;\n  margin-bottom: 10px;\n  border-radius: 5px;\n  position: relative;\n}\n\n/* Fixed Top Navigation Bar */\n.navbar {\n  width: 100%;\n  height: 50px;\n  /* Fixed height */\n  background-color: #ffffff;\n  color: #f2f5f500;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 0 20px;\n  box-sizing: border-box;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n  /* Ensures it stays on top */\n  border-bottom: 2px solid #ccc;\n  /* Separation line */\n}\n\n/* Navbar Links */\n.navbar a {\n  color: #1e1e1e;\n  text-decoration: none;\n  padding: 10px 15px;\n  margin-left: 15px;\n  font-weight: bold;\n  border-radius: 4px;\n}\n\n.navbar a:hover {\n  text-decoration: underline;\n  background-color: transparent;\n}\n\n/* Main Content Area (Adjusted to not overlap Navbar) */\n.main-content {\n  display: flex;\n  flex: 1;\n  padding-top: 50px;\n  overflow: hidden;\n}\n\n.profile-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background-color: rgb(12,12,12);\n}\n\n.profile-card {\n  width: 400px;\n  padding: 20px;\n  border-radius: 10px;\n  background: rgb(12,12,12);\n  text-align: center;\n}\n\n.profile-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 20px;\n  color: white;\n}\n\n.avatar {\n  width: 80px;\n  height: 80px;\n  background: #007bff;\n  color: white;\n  font-size: 40px;\n  font-weight: bold;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 10px;\n}\n\n.profile-body {\n  text-align: left;\n}\n\n.profile-field {\n  margin-bottom: 15px;\n}\n\n.profile-field label {\n  display: block;\n  font-weight: bold;\n  margin-bottom: 5px;\n  color: #fff;\n}\n\n.profile-field input {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n  background-color: #f9f9f9;\n  box-sizing: border-box;\n}\n\n.profile-field input:read-only {\n  background-color: #e9ecef;\n  cursor: not-allowed;\n}\n\n.button-container {\n  margin-top: 20px;\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n}\n\n.save-button {\n  padding: 10px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.save-button:hover {\n  background-color: #0056b3;\n}\n\n.cancel-button {\n  padding: 10px;\n  background-color: #ccc;\n  color: black;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.cancel-button:hover {\n  background-color: #b3b3b3;\n}\n\n/* Account container (wraps My Account and dropdown links) */\n.account-container {\n  position: relative;\n  display: inline-block;\n  font-weight: bold;\n  cursor: pointer;\n  padding: 10px 15px;\n}\n\n/* My Account link */\n.account-links {\n  display: none; /* Hidden by default */\n  transition: opacity 0.3s ease-in-out;\n  margin-left: 10px; /* Space from My Account */\n}\n\n/* Dropdown container (hidden by default) */\n.account-dropdown {\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%); /* Centers it under My Account */\n  background: white;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n  border-radius: 6px;\n  padding: 10px;\n  min-width: 120px;\n  text-align: center;\n}\n\n.account-link:hover {\n  color: #007bff;\n}\n\n/* Dropdown links */\n.account-links a {\n  color: #333;\n  text-decoration: none;\n  padding: 10px;\n  font-size: 14px;\n  transition: color 0.3s ease-in-out;\n}\n\n/* Show dropdown when hovering over My Account */\n.account-container:hover .account-dropdown {\n  display: block;\n}\n\n/* Style on hover */\n.account-links a:hover {\n  color: #007bff;\n  text-decoration: underline;\n}\n\n.account-container:hover .account-links {\n  display: inline-block;\n  opacity: 1;\n}\n\n/* Ensure content starts below the navbar */\n.session-container {\n  width: 90%;\n  margin: 80px auto 30px;\n  /* 80px margin from top to prevent navbar overlap */\n  text-align: center;\n}\n\n/* Sessions Table */\n.session-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n}\n\n.session-table th,\n.session-table td {\n  border: 1px solid #ddd;\n  padding: 10px;\n  text-align: center;\n}\n\n.session-table th {\n  background-color: #2b6cb0;\n  color: white;\n  font-weight: bold;\n}\n\n.session-table tr {\n  background-color: #f9f9f9;\n}\n\n.session-table tr:hover {\n  background-color: #f1f1f1;\n}\n\n/* Revoke Button */\n.revoke-button {\n  background-color: #ff4d4d;\n  color: white;\n  border: none;\n  padding: 8px 12px;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.revoke-button:hover {\n  background-color: #cc0000;\n}\n\n/* No Sessions Found */\n.no-sessions {\n  text-align: center;\n  font-style: italic;\n  color: #888;\n}\n\n/* Delete Account Button */\n.delete-account-button {\n  background-color: red;\n  color: white;\n  border: none;\n  padding: 12px 16px;\n  margin-top: 20px;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.delete-account-button:hover {\n  background-color: darkred;\n}\n\n.delete-account-cancel-button {\n  background-color: #ccc;\n  color: black;\n  border: none;\n  padding: 12px 16px;\n  margin-top: 20px;\n  cursor: pointer;\n  border-radius: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
